<template>
  <div class="school-label">
    <el-button
      size="mini"
      type="primary"
      @click="addSubject"
      icon="el-icon-plus"
      >添加新分类</el-button
    >
    <div class="table-style">
      <el-table
        size="mini"
        :data="videoList"
        :header-cell-style="{ background: '#f5f7fa' }"
      >
        <el-table-column
          align="center"
          prop="sort_num"
          label="排序号"
          width="100"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="name"
          label="分类名称"
        ></el-table-column>

        <el-table-column
          align="center"
          prop="created_time"
          label="创建时间"
        ></el-table-column>


        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="updateTag(scope.row)"
              >修改</el-button
            >
            <el-button size="mini" type="danger" @click="deleteTag(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog title="新增视频类型" :visible.sync="dialogVisible">
      <el-form
        class="form-style"
        ref="form"
        :model="form"
        :rules="rules"
        label-width="100px"
        size="small"
        label-position="left"
      >
        <el-form-item label="排序号" required prop="sort_num">
          <el-input-number
            v-model="form.sort_num"
            :precision="0"
          ></el-input-number>
        </el-form-item>

        <el-form-item label="视频名称" required prop="name">
          <el-input
            placeholder="请输入视频名称"
            v-model="form.name"
            style="width: 400px"
          >
          </el-input>
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="quitDialog('form')">取 消</el-button>
        <el-button size="small" type="primary" @click="submit('form')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getEducationalInstitutionList,
  adminCreateOrUpdateVideoType,
  getVideoTypeList,
  adminDeleteVideoType
} from "@/api/admin.js";
export default {
  name: "course-label",
  data() {
    return {
      educational_institution_list: [],
      total: 0,
      page_no: 1,
      tagId: "",
      form: {
        name: "",
        sort_num: 1,
        remark: "",
        color: "",
      },
      tableData: [],
      dialogVisible: false,
      rules: {
        name: [
          {
            required: true,
            message: "请输入标题",
            trigger: "change",
          },
          {
            required: true,
            message: "请输入标题",
            trigger: "blur",
          },
        ],
      },
      schoolTagList: [],
      videoList:[]
    };
  },
  mounted() {
    this.getVideoTypeList();
  },
  methods: {
    // 获取合作学校列表
    getEducationalInstitutionList(query) {
      getEducationalInstitutionList({
        educational_institution_name: query,
        page_size: 200,
      }).then((res) => {
        this.educational_institution_list = res.educational_institution_list;
      });
    },

    getVideoTypeList() {
      getVideoTypeList().then((res) => {
        console.log("查询视频分类列表");
        console.log(res);
        this.videoList = res.videoList;
      });
    },

    handleCurrentChange(val) {
      this.page_no = val;
    },
    addSubject() {
      this.dialogVisible = true;
      this.form.subject_name = "";
      this.form.sort_num = 1;
      this.form.educational_institution_id = "";
      this.form.color = "";
      this.getEducationalInstitutionList();
    },
    quitDialog(formName) {
      this.tagId = "";
      this.$refs[formName].resetFields();
      this.dialogVisible = false;
    },
    updateTag(row) {
      this.tagId = row.id;
      this.form.name = row.name;
      this.form.color = row.color;
      this.form.remark = row.remark;
      this.form.sort_num = row.sort_num;
      this.dialogVisible = true;
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.tagId) {
            adminCreateOrUpdateVideoType(
              {
                video_type_id: this.tagId,
                name: this.form.name,
                sort_num: this.form.sort_num,
              },
              true
            ).then(() => {
              this.$message.success("修改视频分类成功！");
              this.dialogVisible = false;
              this.getVideoTypeList();
    
            });
          } else {
            console.log("新增视频标签");
            console.log(this.form);

            adminCreateOrUpdateVideoType(
              {
                name: this.form.name,
                sort_num: this.form.sort_num,
              },
              true
            ).then(() => {
              this.$message.success("添加视频分类成功！");
              this.dialogVisible = false;
              this.getVideoTypeList();
            });
          }
        }
      });
    },

    deleteTag(row) {

        adminDeleteVideoType(
          {
            video_type_id: row.id,
          },
          true
        ).then(() => {
          this.$message.success("删除成功！");
          this.getVideoTypeList();

        });

    },
  },
};
</script>

<style scoped lang="scss">
.school-label {
  height: 100%;
  background-color: #fff;
  padding: 15px;
  margin: 15px;
  border-radius: 5px;
  .form-style {
    margin-left: 15px;
  }
  .table-style {
    margin-top: 20px;
  }
}
</style>
